(function () {
  'use strict';

  angular
    .module('app')
    .component('transportationPickupCostDetail', transportationPickupCostDetail());

  function transportationPickupCostDetail() {
    return {
      bindings: {
        transportationPickupCosts: '=',
        transportation: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        provider: '=',
        zones: '=',
        onTransportationPickupCostsSaved: '&',
        onTransportationPickupCostsCanceled: '&',
      },
      controller: TransportationPickupCostDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/transportation-costs/transportation-pickup-cost-detail/transportation-pickup-cost-detail.component.html',
    };
  }

  TransportationPickupCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TransportationCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TransportationPickupCostDetailComponent(
    config,
    UtilService,
    TransportationCostService,

    // Angular downgraded service
    paxRangeService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.saveTransportationPickupCosts = saveTransportationPickupCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          //selectPaxRange(item);
          setZonesData();
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          //selectPaxRange(paxRangeToSelect);
          setZonesData();
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.transportationPickupCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.transportationPickupCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PICKUP_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PICKUP_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.transportationPickupCosts.forEach(function (transportationPickupCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (
            !checkIfPaxRangeExist(paxRange) &&
            transportationPickupCost.pax_range_id === paxRange.id
          ) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Seta all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.zonesData = [];

      vm.zones.forEach(function (zone) {
        zone.pax_ranges = [];

        vm.paxRanges.forEach(function (paxRange) {
          var transportationPickupCostId;
          var serviceCost = 0;

          // Exist transportation pickup costs
          if (vm.transportationPickupCosts.length) {
            for (var i = 0; i < vm.transportationPickupCosts.length; i++) {
              var transportationPickupCost = vm.transportationPickupCosts[i];

              if (
                transportationPickupCost.zone_id === zone.id &&
                transportationPickupCost.pax_range_id === paxRange.id
              ) {
                transportationPickupCostId = transportationPickupCost.id;

                serviceCost = transportationPickupCost.service_cost;
                break;
              }
            }
          }

          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (paxRange.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          var zonePaxRange = {
            id: paxRange.id,
            service_cost: serviceCost,
            pax_from: paxRange.pax_from,
            visible: visible,
            transportationPickupCostId: null,
          };

          if (transportationPickupCostId) {
            zonePaxRange.transportationPickupCostId = transportationPickupCostId;
          }

          zone.pax_ranges.push(zonePaxRange);
        });

        vm.zonesData.push(zone);
      });
    }

    // Show/hide zone pax ranges, based on the paxRangesSelected
    function setZonesData() {
      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          var visible = false;
          for (var j = 0; j < vm.paxRangesSelected.length; j++) {
            var paxRangeSelected = vm.paxRangesSelected[j];
            if (pax_range.id === paxRangeSelected.id) {
              visible = true;
              break;
            }
          }

          pax_range.visible = visible;
        });
      });
    }

    function saveTransportationPickupCosts() {
      var transportationPickupCosts = [];

      vm.zonesData.forEach(function (zone) {
        zone.pax_ranges.forEach(function (pax_range) {
          if (pax_range.visible) {
            var cost = {
              service_cost: pax_range.service_cost || 0,

              zone_id: zone.id,
              pax_range_id: pax_range.id,
              id: null,
            };

            if (pax_range.transportationPickupCostId) {
              cost.id = pax_range.transportationPickupCostId;
            }

            transportationPickupCosts.push(cost);
          }
        });
      });

      var params = {
        transportation_pickup_costs: transportationPickupCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
      };

      vm.sendingForm = true;
      TransportationCostService.saveTransportationPickupCosts(
        vm.transportation,
        params,
        vm.editMode
      ).then(function (data) {
        vm.onTransportationPickupCostsSaved();

        setItemOptions(data[0].updated_at);

        vm.transportationPickupCosts = data;
        setPaxRangesData();

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTransportationPickupCostsCanceled();
    }
  }
})();
